import Vue from 'vue'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'

export default Vue.extend({
  components: {
    AscTextFieldInput,
  },

  data: function () {
    return {
      filterText: null,
    }
  },

  watch: {
    // eslint-disable-next-line no-unused-vars
    filterText(newFilterText, oldFilterText) {
      this.params.filterChangedCallback()
    },
  },
  methods: {
    isFilterActive() {
      return (
        this.filterText !== null &&
        this.filterText !== undefined &&
        this.filterText !== ''
      )
    },

    doesFilterPass(params) {
      const rowData = params.data

      if (this.isFilterActive()) {
        const filterText = this.filterText.toLowerCase()

        return rowData.alertTypes.some(
          alert =>
            alert.name.toLowerCase().includes(filterText) ||
            alert.analyticName.toLowerCase().includes(filterText) ||
            alert.component.toLowerCase().includes(filterText),
        )
      }
    },

    getModel() {
      return this.isFilterActive() ? this.filterText : null
    },

    setModel(model) {
      this.filterText = model
    },

    myMethodForTakingValueFromFloatingFilter(value) {
      this.filterText = value
    },
  },

  template: `<asc-text-field-input
  type="text"
  v-model="filterText"
  :dense="true"
  :hide-details="true"
  style="margin-bottom: 0.5em;" />`,
})
